module.exports = __webpack_public_path__ + "static/media/logomain.37cda906.png";